import React, { useState } from "react";

import retailImg from "../../assets/retail.png";
import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";

import { FaRobot, FaShoppingCart } from "react-icons/fa";

const styles = `
  .retail-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .retail-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .retail-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47, 183, 164, 0.7);
  }

  .retail-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0, 0, 0, 0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 100%;
    max-width: 520px;
    box-sizing: border-box;
  }

  .retail-header-icon-box {
    width: 36px;
    height: 36px;
    min-width: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .retail-header-badge span:first-of-type {
    font-size: 14px;
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .retail-arrow {
    margin-left: auto;
    flex-shrink: 0;
  }

  .retail-header-right {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .retail-header-right h2 {
    margin-left: 10px;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .retail-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .retail-img-wrapper {
    width: 50%;
    flex-shrink: 0;
  }

  .retail-img-wrapper img {
    width: 100%;
    display: block;
  }

  .retail-accordion {
    width: 50%;
  }

  .retail-accordion-item {
    margin-bottom: 18px;
  }

  .retail-accordion-header {
    background: linear-gradient(90deg, #2fb7a4, #2f4a7f);
    color: #fff;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    user-select: none;
    font-weight: 600;
  }

  .retail-accordion-arrow {
    flex-shrink: 0;
    margin-left: 12px;
    font-size: 18px;
  }

  .retail-accordion-body {
    padding: 15px;
    color: #555;
  }

  /* ── Tablet (≤ 1024px) ── */
  @media (max-width: 1024px) {
    .retail-header {
      height: auto;
      min-height: 90px;
    }

    .retail-header-badge {
      max-width: 100%;
      padding: 10px 14px;
    }

    .retail-header-right h2 {
      font-size: 26px;
    }

    .retail-main {
      padding: 40px 40px;
      gap: 40px;
    }
  }

  /* ── Small tablet / large phone (≤ 768px) ── */
  @media (max-width: 768px) {
    .retail-header {
      flex-direction: column;
      height: auto;
    }

    .retail-header-left {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .retail-header-right {
      flex: none;
      min-height: 70px;
      padding: 12px 16px;
    }

    .retail-header-right h2 {
      font-size: 22px;
    }

    .retail-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .retail-img-wrapper {
      width: 100%;
    }

    .retail-accordion {
      width: 100%;
    }
  }

  /* ── Mobile (≤ 480px) ── */
  @media (max-width: 480px) {
    .retail-header {
      flex-direction: column;
      height: auto;
    }

    .retail-header-left {
      min-height: 60px;
      padding: 10px 12px;
    }

    .retail-header-badge {
      padding: 10px 12px;
      gap: 8px;
    }

    .retail-header-badge span:first-of-type {
      font-size: 12px;
    }

    .retail-header-icon-box {
      width: 30px;
      height: 30px;
      min-width: 30px;
    }

    .retail-header-right {
      min-height: 60px;
      padding: 10px 12px;
    }

    .retail-header-right h2 {
      font-size: 18px;
    }

    .retail-header-right svg {
      font-size: 24px !important;
    }

    .retail-main {
      padding: 20px 12px;
      gap: 20px;
    }

    .retail-accordion-header {
      font-size: 13px;
      padding: 10px 12px;
    }

    .retail-accordion-body {
      padding: 12px;
      font-size: 14px;
    }
  }

  /* ── Extra small (≤ 360px) ── */
  @media (max-width: 360px) {
    .retail-header-right h2 {
      font-size: 15px;
    }

    .retail-accordion-header {
      font-size: 12px;
      padding: 8px 10px;
    }
  }
`;

function RetailPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Improved Advertisement",
      content: "AI helps place ads effectively to attract customers."
    },
    {
      title: "2.Stores can become cashier-free",
      content: "Automation reduces queues and improves efficiency."
    },
    {
      title: "3.In-store assistance",
      content: "AI assistants guide customers inside stores."
    },
    {
      title: "4.Virtual fitting rooms",
      content: "Customers can try products virtually."
    },
    {
      title: "5.Supply chain management",
      content: "AI optimizes logistics and inventory."
    },
    {
      title: "6.Product classification",
      content: "AI categorizes products efficiently."
    },
    {
      title: "7.Customer satisfaction tracking",
      content: "AI analyzes customer mood and feedback."
    }
  ];

  return (
    <div>
      <style>{styles}</style>

      {/* HEADER SAME */}
      <div className="retail-header">

        <div
          className="retail-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="retail-header-overlay" />

          <div className="retail-header-badge">
            <div className="retail-header-icon-box">
              <FaRobot style={{ color: "#fff" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span className="retail-arrow">›</span>
          </div>
        </div>

        <div className="retail-header-right">
          <FaShoppingCart style={{ fontSize: "32px", color: "#2fb7a4" }} />
          <h2>Retail</h2>
        </div>
      </div>

      {/* MAIN SAME */}
      <div className="retail-main">
        <div className="retail-img-wrapper">
          <img src={retailImg} alt="" />
        </div>

        <div className="retail-accordion">
          {data.map((item, i) => (
            <div key={i} className="retail-accordion-item">
              <div
                className="retail-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="retail-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="retail-accordion-body">
                  {item.content}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default RetailPage;
